import { createReducer, on } from '@ngrx/store';
import { BrainEstreamComputeRangeResponse } from 'brain-data/model/brain-estream-compute-range.model';
import {
  estreamComputeRangeCacheKey,
  loadEstreamComputeRange,
  loadEstreamComputeRangeError,
  loadEstreamComputeRangeSuccess,
} from '../actions/estream-compute-range.action';

export default interface EstreamComputeRangeState {
  responsesByKey: { [key: string]: BrainEstreamComputeRangeResponse };
  loadingByKey: { [key: string]: boolean };
  errorByKey: { [key: string]: Error };
}

export const initialState: EstreamComputeRangeState = {
  responsesByKey: {},
  loadingByKey: {},
  errorByKey: {},
};

export const reducer = createReducer(
  initialState,
  on(loadEstreamComputeRange, (state, { request }): EstreamComputeRangeState => ({
    ...state,
    loadingByKey: {
      ...state.loadingByKey,
      [estreamComputeRangeCacheKey(request)]: true,
    },
  })),
  on(loadEstreamComputeRangeSuccess, (state, { request, response }): EstreamComputeRangeState => {
    const key = estreamComputeRangeCacheKey(request);
    const nextLoading = { ...state.loadingByKey };
    delete nextLoading[key];
    return {
      ...state,
      responsesByKey: { ...state.responsesByKey, [key]: response },
      loadingByKey: nextLoading,
    };
  }),
  on(loadEstreamComputeRangeError, (state, { request, error }): EstreamComputeRangeState => {
    const key = estreamComputeRangeCacheKey(request);
    const nextLoading = { ...state.loadingByKey };
    delete nextLoading[key];
    return {
      ...state,
      loadingByKey: nextLoading,
      errorByKey: { ...state.errorByKey, [key]: error },
    };
  }),
);
